import { Flex } from "antd";
import { AvatarImage } from "../../components/ContactWithPresenter/AvatarImage";
import { getFaceProfileImagePath } from "../../components/ContactWithPresenter/helpers";
import { SliderVoicePreview } from "../../components/ContactWithPresenter/SliderVoicePreview";
import type { FaceProfileResponse, VoiceProfileResponse } from "../../types";
import { useAntTheme } from "hooks/useAntTheme/";
import { MicrophoneButton } from "../../components/ContactWithPresenter/MicrophoneButton";
import { radius } from "@libertify/ui";

export const AvatarPreview = ({
  avatar,
  voice,
  organizationId,
  currentlyPlayedVoice,
  setCurrentlyPlayedVoice,
}: {
  avatar?: FaceProfileResponse | null;
  voice: VoiceProfileResponse;
  organizationId?: string;
  currentlyPlayedVoice?: VoiceProfileResponse;
  setCurrentlyPlayedVoice: (voice?: VoiceProfileResponse) => void;
}) => {
  const { theme } = useAntTheme();
  const path = getFaceProfileImagePath(avatar);
  return (
    <Flex
      style={{
        width: "100%",
        minHeight: 0,
      }}
      gap="middle"
      vertical
    >
      <Flex
        justify="center"
        align="center"
        style={{
          width: "100%",
          aspectRatio: "1",
          overflow: "hidden",
          borderRadius: radius.box,
          backgroundColor: theme.colorBgElevated,
        }}
      >
        {path ? (
          <AvatarImage
            src={path}
            alt={avatar?.name ?? ""}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <MicrophoneButton
            fillColor={theme.colorTextBase}
            style={{
              width: "100%",
              height: "100%",
            }}
            iconStyle={{ width: "25%", height: "25%" }}
          />
        )}
      </Flex>
      <SliderVoicePreview
        voice={voice}
        currentlyPlayedVoice={currentlyPlayedVoice}
        onClickPlay={(voice) => {
          setCurrentlyPlayedVoice(voice);
        }}
        organizationId={organizationId}
      />
    </Flex>
  );
};
